module.exports = __webpack_public_path__ + "img/MoonPay1.b1752dcc.png";